import { useEffect } from 'react'
import { Card, Typography, Spin } from 'antd'
import { useDispatch } from 'react-redux'
import keycloakAuth from '../services/keycloakAuth'
import authService from '../services/authService'
import { clearCredentials, markLogoutComplete } from '../store/slices/authSlice'
import './RedirectScreen.css'

const { Text, Title } = Typography

const LoggedOut = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    // Clear local auth data when user lands on logged-out page
    authService.clearAuth()
    dispatch(clearCredentials())
    dispatch(markLogoutComplete())
  }, [dispatch])

  useEffect(() => {
    const timer = setTimeout(() => {
      keycloakAuth.login(true)
    }, 1000)

    return () => clearTimeout(timer)
  }, [])

  return (
    <div className="redirect-screen">
      <Card className="redirect-card" bodyStyle={{ padding: 40 }} bordered={false}>
        <div className="redirect-card__icon">
          <img src="/logo.png" alt="Quantum Husky" />
        </div>
        <Title level={3} className="redirect-card__title">
          You have signed out safely
        </Title>
        <Text type="secondary" className="redirect-card__hint">
          Redirecting to the login page...
        </Text>
        <div className="redirect-card__spinner">
          <Spin size="small" />
        </div>
        <div className="redirect-dots" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      </Card>
    </div>
  )
}

export default LoggedOut
